<template>
    <el-dialog :visible.sync="visible"
               :title="!dataForm.id ? $t('user.authApply') : $t('user.authApply')"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               width="1000px">
        <el-form :model="dataForm"
                 :rules="dataRule"
                 ref="dataForm"
                 style="margin-top:10px;padding-bottom:50px"
                 label-position="top">
            <el-row style="margin-top:20px">
                <el-col :span="5">
                    <el-form-item label=""></el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="">
                        <span style="font-size:16px;font-weight:bold">变更前</span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label=""></el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="">
                        <span style="font-size:16px;font-weight:bold">变更后</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row style="margin-top:20px">
                <!--权限分类 -->
                <el-col :span="6">
                    <el-form-item :label="$t('user.permissionclassification')"
                                  prop="">
                        <el-select v-model="dataForm.authType"
                                   filterable
                                   placeholder=""
                                   :disabled="true">
                            <el-option v-for="(item,index) in perClassification"
                                       :key="index"
                                       :label="item.name"
                                       :value="item.code">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label=""></el-form-item>
                </el-col>
                <!--权限分类 -->
                <el-col :span="6">
                    <el-form-item :label="$t('user.permissionclassification')"
                                  prop="authType">
                        <el-select v-model="dataForm.targetAuthType"
                                   filterable
                                   @change="changeAuthType">
                            <el-option v-for="(item,index) in perClassification"
                                       :key="index"
                                       :label="item.name"
                                       :value="item.code">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12"
                        style="text-align:center">
                    <!-- 角色 -->
                    <el-form-item class="role-div"
                                  :label="$t('user.role')"
                                  prop=""
                                  style="width:90% !important">
                        <el-input type="textarea"
                                  autosize
                                  :rows="4"
                                  placeholder=""
                                  v-model="dataForm.roleNames"
                                  :disabled="true">
                        </el-input>
                    </el-form-item>
                </el-col>
                <!-- 角色 -->
                <el-col :span="12"
                        style="text-align:center">
                    <el-form-item :label="$t('user.role')"
                                  prop="targetRoleIds"
                                  style="width:90% !important;">
                        <el-select v-model="dataForm.targetRoleIds"
                                   multiple
                                   collapse-tags
                                   @change="changeRole()"
                                   :placeholder="$t('organization.orgCodeBring')"
                                   class="roletext"
                                   :disabled="canEdit">
                            <el-option v-for="(item,index) in rolelist"
                                       :key="index"
                                       :label="item.roleName"
                                       :value="item.roleId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <!-- 已上传文件 -->
                <el-col :span="12"
                        style="text-align:center"
                        v-if="this.dataForm.authType ==='10' && this.applyShow === '10'">
                    <el-form-item :label="$t('authApply.fileName')"
                                  prop="">
                        <el-input v-model="dataForm.effectiveFileName"
                                  disabled="true"   class="fl-input"  style=""
                                  @click.native="downloadEffectiveFile"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12"
                        v-if="this.dataForm.authType !=='10'">
                    <el-form-item label=""></el-form-item>
                </el-col>
                <el-col :span="6"
                        v-if="this.dataForm.authType !== '10' && this.dataForm.targetAuthType === '10' && this.applyShow === '10'">
                    <el-form-item>
                        <!-- 选取文件 -->
                        <el-upload class="upload-demo"
                                   ref="upload"
                                   accept=".pdf,.PDF,.jpg,.jpeg,.png,.bmp,.JPG,.JPEG,.BMP,.PNG"
                                   :show-file-list="false"
                                   :data="myData"
                                   :headers="myHeader"
                                   :action="uploadUrl"
                                   :on-preview="handlePreview"
                                   :on-remove="handleRemove"
                                   :on-success="handleSuccess"
                                   :before-upload="beforeExcelUpload"
                                   :file-list="fileList"
                                   :auto-upload="true"
                                   :multiple="false"
                                   :on-change="changeFile">

                            <el-button slot="trigger"
                                       type="primary"
                                       style="margin-top: 27px; width: 200px">选择上传文件
                                <el-tooltip placement="top-start" effect="light" :content="$t('authApply.fileFormatContent')">
                                    <em class="el-icon-question"></em>
                                </el-tooltip>
                            </el-button>
                            <el-link type="primary"
                                     @click="downloadTemplate" style="margin-left:7px">模板下载</el-link>
                            <!--<div slot="tip"
                                 class="el-upload__tip">只支持PDF格式，文件不得超过20MB</div>
                                 -->
                        </el-upload>
                    </el-form-item>
                </el-col>
                <el-col :span="6"
                        v-if="this.dataForm.authType !== '10' && this.dataForm.targetAuthType === '10' && this.applyShow === '10'">
                    <el-form-item :label="$t('authApply.fileName')"
                                  prop="fileContent"
                                  :rules="this.dataForm.fileContent === ''||this.dataForm.fileContent === null||this.dataForm.fileContent === undefined? dataRule.fileContent:
            [{ required: false, message: this.$t('validate.required'), trigger: 'change' }]">
                        <el-input v-model="dataForm.fileContent"
                                  :disabled="true"
                                  class="fl-input"
                                  @click.native="downloadFile"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6">
                    &nbsp;
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <el-col :span="6">
                        <el-form-item label="">
                            <span style="font-size:16px;font-weight:bold">当前职位</span>
                        </el-form-item>
                    </el-col>
                </el-col>
            </el-row>
            <el-row>
                <!-- 经销商网点 -->
                <el-col :span="6">
                    <el-form-item :label="$t('user.outlet')"
                                  prop="">
                        <el-input v-model="dataForm.orgName"
                                  :disabled="true"></el-input>
                    </el-form-item>
                </el-col>
                <!-- 职位名称 -->
                <el-col :span="6">
                    <el-form-item :label="$t('position.positionName')"
                                  prop="">
                        <el-input v-model="dataForm.jobName"
                                  :disabled="true"></el-input>
                    </el-form-item>
                </el-col>
                <!-- 兼职网点1 -->
                <el-col :span="6">
                    <el-form-item :label="$t('user.outlet1')"
                                  prop="">
                        <el-input v-model="dataForm.partTimeOutOneName"
                                  :disabled="true"></el-input>
                    </el-form-item>
                </el-col>
                <!-- 职位名称 -->
                <el-col :span="6">
                    <el-form-item :label="$t('user.parttimejob1')"
                                  prop="">
                        <el-input v-model="dataForm.partTimeJobOne"
                                  :disabled="true"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <!-- 兼职网点2 -->
                <el-col :span="6">
                    <el-form-item :label="$t('user.outlet2')"
                                  prop="">
                        <el-input v-model="dataForm.partTimeOutTwoName"
                                  :disabled="true"></el-input>
                    </el-form-item>
                </el-col>
                <!-- 职位名称 -->
                <el-col :span="6">
                    <el-form-item :label="$t('user.parttimejob2')"
                                  prop="">
                        <el-input v-model="dataForm.partTimeJobTwo"
                                  :disabled="true"></el-input>
                    </el-form-item>
                </el-col>
                <!-- 兼职网点3 -->
                <el-col :span="6">
                    <el-form-item :label="$t('user.outlet3')"
                                  prop="">
                        <el-input v-model="dataForm.partTimeOutThreeName"
                                  :disabled="true"></el-input>
                    </el-form-item>
                </el-col>
                <!-- 职位名称 -->
                <el-col :span="6">
                    <el-form-item :label="$t('user.parttimejob3')"
                                  prop="">
                        <el-input v-model="dataForm.partTimeJobThree"
                                  :disabled="true"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <!-- 兼职网点4 -->
                <el-col :span="6">
                    <el-form-item :label="$t('user.outlet4')"
                                  prop="">
                        <el-input v-model="dataForm.partTimeOutFourName"
                                  :disabled="true"></el-input>
                    </el-form-item>
                </el-col>
                <!-- 职位名称 -->
                <el-col :span="6">
                    <el-form-item :label="$t('user.parttimejob4')"
                                  prop="">
                        <el-input v-model="dataForm.partTimeJobFour"
                                  :disabled="true"></el-input>
                    </el-form-item>
                </el-col>
                <!-- 兼职网点5 -->
                <el-col :span="6">
                    <el-form-item :label="$t('user.outlet5')"
                                  prop="">
                        <el-input v-model="dataForm.partTimeOutFiveName"
                                  :disabled="true"></el-input>
                    </el-form-item>
                </el-col>
                <!-- 职位名称 -->
                <el-col :span="6">
                    <el-form-item :label="$t('user.parttimejob5')"
                                  prop="">
                        <el-input v-model="dataForm.partTimeJobFive"
                                  :disabled="true"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24"
                        v-if="this.dataForm.targetAuthType === '10' && this.applyShow === '10'"
                        style="text-align:center">
                    <!-- 允许设为管理员职位 -->
                    <el-form-item class="role-div"
                                  :label="$t('authApply.allowAllowAdminJobNames')"
                                  prop=""
                                  style="width:90% !important;font-size:16px;font-weight:bold ">
                        <el-input type="textarea"
                                  autosize
                                  :rows="4"
                                  placeholder=""
                                  v-model="dataForm.allowAdminJobNames"
                                  :disabled="true">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div style="width:100%;text-align:center">
            <el-button type="primary"
                       style="width:90px;height:36px"
                       @click="dataFormSubmitHandle()"
                       :disabled="isDisable">{{$t('confirm')}}</el-button>
            <el-button style="width:90px;height:36px;margin-left:20px"
                       @click="visible = false">{{$t('cancel')}}</el-button>
        </div>

        <div class="box">
            <div :class="lineFlag"></div>
        </div>

    </el-dialog>

</template>

<script>
    import debounce from 'lodash/debounce'
    import Vue from 'vue'
    import { clearLoginInfo } from '@/utils'
    import AesUtil from "@/utils/aes_utils";
    import $ from 'jquery'
    export default {
        data() {
            return {
                id: '',
                visible: false,
                dataForm: {
                    userId: '',
                    fileManagementId: '',
                    targetRoleIds: []
                    // authType: '',
                    // orgType: ''
                },
                // 角色列表
                rolelist: [],
                uploadUrl: '',
                url: '/sys/commAdminFileManagement/uploadFileMT',
                myHeader: { token: '' }, // token
                fileList: [],
                myData: {},
                isDisable: false,
                canEdit: true,
                fileName: '',
                roleTypeVal: '',
                // 权限分类
                perClassification: this.enums['perClassification'],
                orgType: this.enums['orgType'],
                applyShow: '',
                dataMap: {},
                lineFlag: 'line',
                templeteFileName: ''
            }
        },
        computed: {
            dataRule() {
                return {
                    // 离职原因
                    targetRoleIds: [
                        { required: true, message: this.$t('user.outletNew'), trigger: 'blur' }
                    ],
                    authType: [
                        { required: true, message: this.$t('user.outletNew'), trigger: 'blur' }
                    ],
                    fileContent: [
                        { required: true, message: this.$t('authApply.uploadFileFirst'), trigger: 'blur' }
                    ],

                }
            }
        },
        created() {
            this.uploadUrl = `${window.SITE_CONFIG['apiURL']}` + this.url
            this.myHeader.token = this.getStorage(this.GLOBAL.TOKEN)
            this.roleTypeVal = this.getStorage(this.GLOBAL.USER_DATA).roleTypeVal
            if (this.roleTypeVal === '0' || this.roleTypeVal === '1') {
                this.canEdit = false
            }
            this.$request.get(`/sys/commAdminFileManagement/getTempleteFileName`,
                {
                    paramKey: 'ADMIN_LEVEL_TEMPLETE_FILE'
                }
            ).then((res, total, code, data) => {
                console.info('模板文件名称' + res)
                this.templeteFileName = res

            }).catch(() => { })
        },
        methods: {
            init() {
                this.visible = true
                // 取得配置
                this.$request.get(`/sys/config/acquireOrgTypeSetting`).then((res, total, code, data) => {
                    this.dataMap = new Map()
                    for (let i = 0; i < res.length; i++) {
                        this.dataMap.set(res[i].paramKey, res[i].paramValue)
                    }
                    // 取得页面数据
                    const base64urlTwo = require('base64-url')
                    let aesTwo = new AesUtil()
                    let userid = base64urlTwo.encode(aesTwo.encrypt(this.id + ''))
                    this.$request.get(`/sys/commAuthApply/infoMT/${userid}`).then((res, total, code, data) => {
                        this.dataForm = JSON.parse(JSON.stringify(res))
                        // 初始Auth
                        this.initAuthType(this.dataForm.authType)
                        const base64url = require('base64-url')
                        let aes = new AesUtil()
                        let userId = base64url.encode(aes.encrypt(this.id + ''))
                        this.myData = { userId: userId, type: '20', formal: '20', orgType: this.dataForm.orgType }
                        // 变更设置Line
                        this.changeAuthType(this.dataForm.authType)
                    }).catch(() => { })
                }).catch(() => { })
            },
            initAuthType(val) {
                // 获取角色信息
                const base64urlTwo = require('base64-url')
                let aesTwo = new AesUtil()
                let userid = base64urlTwo.encode(aesTwo.encrypt(this.id + ''))
                this.$request.get(
                    `/sys/commuser/sysRoleMT`,
                    {
                        orgType: this.dataForm.orgType,
                        authType: val,
                        id: userid
                    }
                ).then((res, total, code, data) => {
                    this.rolelist = res.map(item => {
                        item.roleId = item.roleId + ''
                        return item
                    })
                }).catch(() => { })
                if (this.dataForm.targetRoleIds !== '' && this.dataForm.targetRoleIds !== null && this.dataForm.targetRoleIds !== undefined) {
                    if (this.dataForm.targetRoleIds.length > 0) {
                        this.dataForm.targetRoleIds = this.dataForm.targetRoleIds.split(',')
                        // 手动清空检验，否则角色会直接校验是否为空
                        this.$nextTick(function () {
                            this.$refs['dataForm'].clearValidate('targetRoleIds')
                        })
                    } else {
                        this.dataForm.targetRoleIds = []
                    }
                }
            },
            changeAuthType(val) {
                this.$refs.dataForm.clearValidate('targetRoleIds')
                this.dataForm.targetRoleIds = []
                // 获取角色信息
                this.$request.get(
                    `/sys/commuser/sysRoleMT`,
                    {
                        orgType: this.dataForm.orgType,
                        authType: val
                    }
                ).then((res, total, code, data) => {
                    this.rolelist = res.map(item => {
                        item.roleId = item.roleId + ''
                        return item
                    })
                }).catch(() => { })
                if (this.dataForm.orgType !== '' && this.dataForm.orgType !== null) {
                    this.getDefaultRole()
                }
                if (this.dataMap.get('APPLY_ORG_TYPE_' + this.dataForm.orgType)) {
                    this.applyShow = this.dataMap.get('APPLY_ORG_TYPE_' + this.dataForm.orgType)
                }
                this.changeLineFlag()
            },
            changeLineFlag() {
                if (this.applyShow === '10') {
                    // 修改前:管理员
                    if (this.dataForm.authType === '10') {
                        // 修改后管理员
                        if (this.dataForm.targetAuthType === '10') {
                            this.lineFlag = 'line1'
                        } else {
                            this.lineFlag = 'line2'
                        }
                    } else {
                        if (this.dataForm.targetAuthType === '10') {
                            this.lineFlag = 'line3'
                        } else {
                            this.lineFlag = 'line4'
                        }
                    }
                } else {
                     // 修改前:管理员
                    if (this.dataForm.authType === '10') {
                        // 修改后管理员
                        if (this.dataForm.targetAuthType === '10') {
                            this.lineFlag = 'line5'
                        } else {
                            this.lineFlag = 'line6'
                        }
                    } else {
                        if (this.dataForm.targetAuthType === '10') {
                            this.lineFlag = 'line7'
                        } else {
                            this.lineFlag = 'line8'
                        }
                    }
                }
            },
            getDefaultRole() {
                this.$request.post(
                    '/sys/role/queryRoleByType',
                    {
                        orgType: this.dataForm.orgType,
                        authType: this.dataForm.targetAuthType
                    }
                ).then((res, total, code, data) => {
                    this.dataForm.targetRoleIds = []
                    for (let i = 0; i < res.length; i++) {
                        this.dataForm.targetRoleIds.push(res[i].roleId + '')
                    }
                }).catch(() => { })
            },
            // submitUpload(file, fileList) {
            //     this.$refs.upload.submit()
            // },
            handleRemove(file, fileList) {
            },
            handlePreview(file) {

            },
            beforeExcelUpload(file, fileList) {
                if (file == null) {
                    this.$message({
                        message: this.$t('authApply.uploadFileFirst'),  // liujx 请先上传文件',
                        type: 'error',
                        duration: 1500,
                        // onClose: () => {
                        //     this.getDataList()
                        // }
                    })
                    return false
                }
                let maxLength = 20 * 1024 * 1024
                if (file.size > maxLength) {
                    this.$message({
                        message: '文件大小不能超过20M',
                        type: 'error',
                        duration: 1500,
                    })
                    return false
                }
                let fullName = file.name
                let idx = fullName.lastIndexOf(".")
                let extName = fullName.substr(idx + 1);
                extName = extName.toUpperCase()
                let includeExt = new Array('PDF','JPG','JPEG','PNG','BMP') // ('PDF','JPG','JPEG','PNG','PBG','GIF','BMP')
                if (includeExt.indexOf(extName) < 0) {
                    this.$message({
                        message: this.$t('authApply.fileFormatMsg'),  // '请上传PDF格式或图片格式文件',
                        type: 'error',
                        duration: 1500,
                    })
                    return false
                }
                return true
            },
            // 上传成功
            handleSuccess(response, file, fileList) {
                //  this.fileList = []
                this.dataForm.fileManagementId = response.data.fileManagementId
                this.dataForm.fileContent = response.data.fileName
                this.dataForm.filePath = response.data.filePath
                this.$forceUpdate()
            },

            changeFile(file, fileList) {
                if (fileList.length > 1) {
                    fileList.splice(0, 1)
                }
            },
            changeRole() {
                if (this.dataForm.targetRoleIds !== []) {
                    this.$refs.dataForm.clearValidate('targetRoleIds')
                }
            },
            downloadFile() {
                if (this.dataForm.fileContent === '' || this.dataForm.fileContent === null || this.dataForm.fileContent === undefined) {
                    this.$message({
                        message: '管理员申请证明文件不存在',
                        type: 'info',
                        duration: 1500,
                    })
                } else {
                    this.$message({
                        message: this.$t('user.authApplyDownloadFileMessage'),
                        type: 'info',
                        duration: 1000,
                    })
                   // this.$request.download('/sys/commAdminFileManagement/downloadFile',
                   this.$request.downloadBigFile('/sys/commAdminFileManagement/downloadUploadedFile',
                        this.dataForm.fileContent,
                        {
                            fileManagementId: this.dataForm.fileManagementId
                        },
                        null,
                        true
                    )

                }
            },
            downloadEffectiveFile() {
                if (this.dataForm.effectiveFileName !== '' && this.dataForm.effectiveFileName !== null && this.dataForm.effectiveFileName !== undefined) {
                    this.$message({
                        message: this.$t('user.authApplyDownloadFileMessage'),
                        type: 'info',
                        duration: 1000,
                    })
                    this.$request.downloadBigFile('/sys/commAdminFileManagement/downloadUploadedFile',
                    // this.$request.download('/sys/commAdminFileManagement/downloadFile',
                        this.dataForm.effectiveFileName,
                        {
                            fileManagementId: this.dataForm.effectiveFileManagementId
                        },
                        null,
                        true
                    )
                }
            },
            downloadTemplate() {
                this.$request.download('/sys/commAdminFileManagement/downloadTemplate',
                    this.templeteFileName,   /// '模板下载.pdf',
                    {

                    },
                    null,
                    true
                )
            },

            dataFormSubmitHandle: debounce(function () {
                //防止连续点击
                this.isDisable = true
                setTimeout(() => {
                    this.isDisable = false
                }, 5000)
                this.$refs['dataForm'].validate((valid) => {
                    if (!valid) {
                        return false
                    } else {
                        if (this.roleTypeVal !== '0' && this.roleTypeVal !== '1') {
                            if (this.dataForm.authType === this.dataForm.targetAuthType) {
                                this.$message({
                                    message: '当前用信息没有改变，无法提交',
                                    type: 'error',
                                    duration: 1500,
                                })
                                return false
                            }
                        }
                        if (this.dataForm.authType === '10' && this.dataForm.authType !== '10') {
                            this.$message({
                                message: '该用户权限再次变更为管理员权限时，需要重新上传证明进行申请流程',
                                type: 'success',
                                duration: 1500,
                            })
                        }
                        let targetRoleIdStr = this.dataForm.targetRoleIds.join(',')
                        this.$request.post(`/sys/commAuthApply/save`,
                            {
                                userId: this.id,
                                authType: this.dataForm.authType,
                                roleNames: this.dataForm.roleNames,
                                version: this.dataForm.version,
                                targetAuthType: this.dataForm.targetAuthType,
                                targetRoleIds: targetRoleIdStr,
                                orgType: this.dataForm.orgType,
                                fileManagementId: this.dataForm.fileManagementId,
                                approvalStatus: '10',
                                orgId: this.dataForm.orgId,
                                roleIds: this.dataForm.roleIds,
                            }
                        ).then((res, total, code, data) => {
                            this.$message({
                                message: this.$t('prompt.success'),
                                type: 'success',
                                duration: 500,
                                onClose: () => {
                                    this.visible = false
                                    this.$emit('refreshAuthDataList')
                                }
                            })
                            //// 本人由管理员变更为非管理员，需要重新登录 2021-01-30
                            let loginUserId = this.getStorage(this.GLOBAL.USER_DATA).userId
                            if (this.id === loginUserId) {
                                if (this.dataForm.authType === '10' && this.dataForm.targetAuthType !== '10') {
                                    this.$alert('您已被取消了管理员权限，请重新登录系统')
                                    clearLoginInfo()
                                    return
                                }
                            }

                        }).catch(() => { })
                    }
                })
            }, 2000, { 'leading': true, 'trailing': false })
        },
        activated() {
            this.dataForm = {}
        },
    }
</script>
<style lang="scss" scoped>
    .box {
        position: relative;
    }
    // 缺省
    // .line {
    //     height: 250px;
    //     width: 0px;
    //     border: 1px dashed #5e5ee4;
    //     box-sizing: border-box;
    //     position: absolute;
    //     left: 47.5%;
    //     bottom:  -470px;
    //     z-index: 100;
    // }
    .line {
        height: 200px;
        width: 0px;
        border: 1px dashed #5e5ee4;
        box-sizing: border-box;
        position: absolute;
        left: 47.5%;
        top:  -490px;
        z-index: 100;
    }
    // 管理员+ 管理员 = line1  调整高度时，需要同时调整对应的 top才能正常移到线
    .line1 {
        height: 200px;
        width: 0px;
        border: 1px dashed #5e5ee4;
        box-sizing: border-box;
        position: absolute;
        left: 47.5%;
        //bottom:  315px;
        top:  -635px;
        z-index: 100;
    }
    // 管理员+普通用户=line2
    .line2 {
        height: 200px;
        width: 0px;
        border: 1px dashed #5e5ee4;
        box-sizing: border-box;
        position: absolute;
        left: 47.5%;
        top:  -550px;  //-470px;
        z-index: 100;
    }
    // 普通用户+管理员=line3
    .line3 {
        height: 200px;
        width: 0px;
        border: 1px dashed #5e5ee4;
        box-sizing: border-box;
        position: absolute;
        left: 47.5%;
        top:  -643px;  //-470px;
        z-index: 100;
    }
    // 普通用户+普通用户=line4
    .line4 {
        height: 200px;
        width: 0px;
        border: 1px dashed #5e5ee4;
        box-sizing: border-box;
        position: absolute;
        left: 47.5%;
        top:  -470px;  //-470px;
        z-index: 100;
    }

    .fl-input.is-disabled  .el-input__inner {
        color: blue !important;
        text-decoration:underline;
        cursor:pointer;
    }

    .line5 {
        height: 300px;
        width: 0px;
        border: 1px dashed #5e5ee4;
        box-sizing: border-box;
        position: absolute;
        left: 47.5%;
        //bottom:  315px;
        top:  -615px;
        z-index: 100;
    }
    // 管理员+普通用户=line2
    .line6 {
        height: 300px;
        width: 0px;
        border: 1px dashed #5e5ee4;
        box-sizing: border-box;
        position: absolute;
        left: 47.5%;
        top:  -550px;  //-470px;
        z-index: 100;
    }

    // 没有设置上传，即APPLY_ORG_TYPE_XX = 20
    .line7 {
        height: 240px;
        width: 0px;
        border: 1px dashed #5e5ee4;
        box-sizing: border-box;
        position: absolute;
        left: 47.5%;
        top:  -468px;  //-470px;
        z-index: 100;
    }
    .line8 {
        height: 200px;
        width: 0px;
        border: 1px dashed #5e5ee4;
        box-sizing: border-box;
        position: absolute;
        left: 47.5%;
        top:  -470px;  //-470px;
        z-index: 100;
    }


</style>


